import React from 'react';
import { motion } from 'framer-motion';
import { SlideFrame } from '../deck/SlideFrame';
import { SnakkerMark } from '../deck/SnakkerMark';
export function TitleSlide() {
  return <SlideFrame marker="Snakker thoughts-material" meta="Illustrative example" data-id="element-154" data-mp="gc3zscvs4tz5">
      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-155" data-mp="g9zkyzwceak3">
        <SnakkerMark size="lg" showLabel={false} data-id="element-156" data-mp="ca8z9aloakmf" />
        <p className="mt-[2vh] text-[clamp(10px,1.15vw,18px)] font-semibold uppercase tracking-[0.25em] text-gapAccent" data-id="element-157" data-mp="7be8nmhgrrrr">
          Thoughts-material
        </p>
        <h1 className="mt-[1.6vh] font-display text-[clamp(32px,5.4vw,98px)] leading-[1.02] tracking-[-0.005em] text-ink" data-id="element-158" data-mp="2b9onmhckews">
          Mind the gap.
        </h1>
        <p className="mt-[2.4vh] max-w-[52ch] text-[clamp(13px,1.5vw,25px)] leading-[1.4] text-ink-soft" data-id="element-159" data-mp="3pi27iulx7ioz">
          How we work when we start on a new brand — and how we decide where the
          money goes.
        </p>

        <motion.div className="mt-[3vh] flex flex-wrap items-center gap-[1.5%] border-t border-ink-line pt-[2vh]" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-160" data-mp="1nqfg4ry49lrz">
          {['Prescription criteria', 'HCP perception', 'Internal fact base', 'Gap model'].map(item => <span key={item} className="rounded-2xl border border-ink-line bg-paper-card px-[1.6vw] py-[1.2vh] text-[clamp(10px,1.1vw,18px)] font-medium text-ink" data-id="element-161" data-mp="1ei0bwc2jenmy">
              {item}
            </span>)}
        </motion.div>

        <p className="mt-[1.8vh] max-w-[62ch] text-[clamp(10px,1.15vw,18px)] leading-[1.45] text-ink-mute" data-id="element-162" data-mp="15nluo3yg5317">
          The baseline of impact is shown as “perception” — that data can come
          from a third party or be gathered as part of the project.
        </p>
      </div>
    </SlideFrame>;
}